const Form030EN = {
    stepName: {
        statement: "Important Notes",
        information: "Information",
        check: "Application Form Selection",
        sectionA: "Section A",
        sectionB: "Section B",
        sectionC: "Section C",
        sectionD: "Section D",
        certify: "Certification",
        confirmation: "Confirmation",
    },
    notesTitle: "Personal Information Collection Statement",
    labelStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
    ],
    errorMsg: {
        date: {
            afterThisDate: "Please select a date after {{name}} {{targetDate}}",
            beforeThisDate:
                "Please select a date before {{name}} {{targetDate}}",
            laterThanDate:
                "The Date cannot be later than 31 Aug of the subject school year",
            leaveDays: "Sch: leave days>=1 day;Bdg: leave days>2 days",
            lessThanThree:
                "leave period is less than 3 consecutive calendar days, please choose again",
        },
        minNum: "This field must be greater than 0",
        digits: "Maximum {{max}} digits",

        mpf: 'When "No. of working days">=60 or "Number of Qualified Months">=2, no MPF is allowed',
        workingDay:
            "The number of working days should not be greater than number of days as contained in the supply period.",
        calendarDay:
            "The number of calendar days and the number of working days should not be greater than the number of days as contained in the leave period.",
        calendarWorkingDays:
            "The number of working days should not be greater than the number of calendar days.",
    },
    label: {
        specifyRank: "Specify the Rank",
        seniorSchoolDevelopmentOfficer: "Senior School Development Officer",
        schoolYear: "School Year",
        role: {
            teacher: "Teacher",
            assistant: "Assistant",
            cook: "Cook",
            specialDriver: "Special Driver",
            watchman: "watchman",
        },
        numberOfVacantPosts:
            "Number of vacant post(s) in exchange for Cash Grant for Teacher Assistant",
        notes: "Note",
        terms: "Statement",
        agree: "Applicants should read carefully and agree",
        data: "Notes on private data",
        read: "I have read, understood and agreed to the above terms and conditions",
        schoolInfor: "School Information",
        schoolName: "School Name",
        schoolCode: "School Code",
        month: "Month",
        year: "Year",
        example: "For example: ",
        assuming:
            "Assuming the Qualified Period for SNG starts from 5 February to 26 May, the Number of Qualified Months should be calculated as follows:",
        claimSNG: "Application Form Selection",
        selectSNG: "Please select",
        claim: "New claim post/Revised claim",
        post: "Post",
        section: "Section",
        supplyPeriod: "Supply Period",
        leavePeriod: "Leave Period",

        calendar: "No. of Calendar days",
        a: "No. of working days",
        b: "Daily Rate",
        workingDay: "No. of working days",
        dailyRate: "Daily Rate",
        c: "Number of Qualified Months",
        d: "Monthly Salary",
        e: "MPF Subsidy",
        subsidy: "MPF Subsidy",
        f: "SNG Amount",
        salaryAmount: "Salary Amount",
        totalSNG: "Total(SNG Amount)",
        totalSTG: "Total(STG Amount)",
        attached:
            "N: New claim post /R: Revised claim(Copy of previous claim dated: ________________attached)",
        attachedTitle: "Copy of previous claim dated attached",
        remark: "Remark",
        indicate: "Please indicate the following documents",
        leaveInfor: "Information of the teacher(s) on leave",
        sngInfor: "Information for SNG",
        name: "Name",
        srn: "SRN",
        reason: "Reason for absence",
        otherReason: "other paid leave (please specify the reason)",
        claimDailyRated:
            "I would like to claim daily-rated supply teacher reimbursement as follows:",
        supplyInfo: "Information of supply teacher",
        supplyTeacherInfo: "Information of the Supply Teacher",
        supplyTeacherLeave: "Information of the Teacher on Leave",
        sTGCalculation: "Information of STG Calculation",
        supplyName: "Name of supply teacher",
        supplyFrom: "Supply period From",
        supplyTo: "Supply period To",
        salaryTotal: "Total(Salary Amount)",
        subsidyTotal: "Total(MPF subsidy)",
        staffNumber: "Staff Number",
        contractFrom: "Contract period From",
        contractPeriod: "Contract period",
        contractTo: "Contract period To",
        salarySubTotal: "Sub-total(Salary Amount)",
        subsidySubTotal: "Sub-total(MPF subsidy)",
        allTotal: "Total",
        STGAmount: "STG Amount",
        allSTGTotal: "Total (STG Amount)",
        ratePerDay: "Rate per Day",
        certify: "I certify that:",
        emoluments: "The emoluments have been paid",
        needCheck: "You need to select at least one option",
        number: "Please enter the number type",
        leave: "Leave Period",
        vacancyPeriod: "Vacancy Period",
        previousClaimDated: "Copy of previous claim dated",
        attachment: "Attachment",
        MPFAttachment: "Attachment for MPF Schemes",
        postNumber: "Number of post",
        dailyRateAttachment:
            "Attachment for reimbursement of daily-rated supply teacher",
        previousClaim: "Previous Claim",
        previousClaimNumber:
            "Please indicate the application number of previous claim form",
        from: "From",
        to: "To",
        FreezeFrom: "Freeze period of the vacant post(s) From (dd/mm/yy)",
        FreezeTo: "Freeze period of the vacant post(s) To (dd/mm/yy)",
        MPFInformation: "MPF Supporting Information",
        postNo: "No of post",
        applicationNo: "Application Number",
        date: "Date",
        contactPerson: "Contact Person",
        telNo: "Tel No.",
        sSDO: "SSDO",
        numberofQualifiedMonths: "Number of Qualified Months",
        monthlySalary: "Monthly Salary",
        MPFSubsidy: "MPF Subsidy",
        AmountofCashGrantforTeacherAssistant:
            "Amount of Cash Grant for Teacher Assistant",
        numberOfVacantPostsForCook:
            "Number of vacant post(s) in exchange for Cash Grant for Cook",
        AmountofCashGrantforCook: "Amount of Cash Grant for Cook",
        numberOfVacantPostsForSpecialDriver:
            "Number of vacant post(s) in exchange for Cash Grant for Special Driver",
        AmountofCashGrantforSpecialDriver:
            "Amount of Cash Grant for Special Driver",
        numberOfVacantPostsForWatchman:
            "Number of vacant post(s) in exchange for Cash Grant for Watchman",
        AmountofCashGrantforWatchman: "Amount of Cash Grant for Watchman",
        allSalaryTotal: "Total Salary",
        allSubTotal: "Total MPF金",
        surplusTeachers: "Surplus Teacher",
        surplusTeachersNumber: "No. of Surplus teachers",
        totalPost: "the total number of posts",
        leaveTeacher: "teachers on leave",
        approvedEstablishment:
            "the teaching posts on the approved establishment",
        graduatePosts: "Graduate posts",
        nongraduatePosts: "Non-graduate posts",
        GNtotal: "Total(Graduate posts + Non-graduate posts)",
        postsClaimed: "No. of Posts Claimed",
        period: "Period",
        note1: "Aided secondary schools have to offset, in order of priority, (a) the fractional staff entitlement; (b) the Senior Secondary Curriculum Support Grant (SSCSG); and (c) the provision of supply teachers by the surplus teaching posts during the 5-year transitional period for surplus teacher under the New Senior Secondary Academic Structure as specified in para. 8 of EDB Circular No. 6/2007 and the toleration period under the Voluntary Optimisation of Class Structure Scheme as specified in para. 4 and 5 of EDB Circular Memorandum No. 190/2010.",
        note2: "For schools joining the Voluntary Optimisation of Class Structure Scheme, the approved teaching staff establishment includes all regular posts approved in the normal teaching staff establishment and the teaching post quota provided in that school year.",
    },
    surplusTeachersOption: {
        Yes: "has",
        No: "has no",
    },

    secValue: {
        Sch: "School Section",
        Bdg: "Boarding Section",
    },
    previousClaimValue: {
        unchange: "Unchange previous claim",
        delete: "Delete previous",
    },
    supplyValue: {
        teacher: "Daily-rated supply teacher",
        trustees: "MPF Scheme trustees concerned",
    },
    sectionValue: {
        SectionA:
            "Section A Daily-rated supply teachers not required to contribute to MPF",
        SectionB:
            "Section B Daily-rated supply teachers required to contribute to MPF",
        SectionC:
            "Section C Substitute Teacher Grant (Vacancies arising from teachers on leave)",
        SectionD:
            "Section D Substitute Teacher Grant (Freezing of teaching posts on the approved establishment)",
    },
    leaveValue: {
        lessThan: "Leave period of less than 30 days",
        moreThan: "Leave period of not less than 30 days",
    },
    vacancyValue: {
        vacancy: "Vacancy period of less than 30 days",
        revocable:
            "Revocable freezing on vacancy period of not less than 30 days",
    },
    claimValue: {
        N: "New claim post",
        R: "Revised claim",
    },
    reasonValue: {
        a: "(a) paid sick/maternity/special tuberculosis leave",
        b: "(b) paid study leave",
        c: "(c) paid leave for teachers for juror or witness service",
        d: "(d) paid leave for a maximum of 14 days per school year for special events as specified in the Annex to EDB Circular No. 1/2006",
        e: "(e) other paid leave (please specify the reason)",
        x: "(x) no-pay sick/maternity/special tuberculosis leave",
        z: "(z) other no-pay leave",
    },
    postValue: {
        NO: "Nuring Officer",
        RN: "Registered teacher",
        EN: "Enrolled teacher",
    },
    adminValue: {
        supervisor: "Supervisor",
        schoolHead: "School Head",
    },
    noteList: [
        {
            text: "1. Enter Staff Reference Number of teachers on leave.",
        },
        {
            text: "2. Please choose the reason of absence from the list below - ",
        },
        {
            text: "3. For supply teachers who have participated in the Early Retirement Scheme for aided primary/secondary school teachers, please note that they are only allowed to take up daily-rated part-time jobs of a duration of not more than 90 days each as set out in EDB Circular No. 5/2005 and Annex 1 to EDB Circular Memorandum No. 9/2012.",
        },
        {
            text: "4. The number of working days should exclude Sunday, Saturday (short-week), public holidays, discretionary holidays or any days on which the teachers are not required to perform duties.",
        },
        {
            text: "5. Please refer to the relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers in aided schools.",
        },
        {
            text: "6. For supply period less than 60 calendar days yet the supply teacher is required to contribute to MPF (5% of the monthly salary capped at maximum amount stipulated under prevailing MPF regulations), please provide supporting information and the relevant contract period.",
        },
        {
            text: "7. Please refer to EDB Circular No. 60/1999 on rates per day for STG and the relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers in aided schools.",
        },
        {
            text: "8. For school joining the Voluntary Optimisation of Class Structure Scheme, the approved teaching staff establishment includes all regular posts approved in the normal teaching staffestablishment and the teaching post quota provided in that school year.",
        },
    ],
    termList: {
        i: "the emoluments have been paid to the supply teacher and/or MPF scheme trustee concerned and relevant receipts being attached for your records;",
        ii1: "the school ",
        ii2: " surplus teachers and the number of surplus teachers has been offset before employing any supply teachers;",
        iii: "consent has been obtained from my school's SMC for claiming STG in the school year;",
        vi: "no salaries grant of teachers filling the vacant posts have been claimed;",
        v1: "the total number of posts",
        v2: "claiming STG including those under Section (C) teachers on leave",
        v3: "and (D) the teaching posts on the approved establishment",
        v4: "<b>does not exceed the ceiling of 10% of the approved teaching staff establishment</b>",
        v5: "<b> of my school (Graduate posts:<b>",
        v6: "<b>; Non-graduate posts:</b>",
        v7: "<b>; Total:</b>",
        v8: "<b>) at the claim date</b> and <u>this request for payment complies with the conditions set out in EDB Circular No. 60/1999.<i>(Please enter number of posts in the space provided)</i></u>;",
        v9: "except the surplus teacher situation mentioned above (if applicable), the sum of the total number of posts claiming STG and the strength of my school would not exceed the approved teaching staff establishment ",
        v10: "no duplicate claim has been made for government subventions on account of the same leave/vacancy/frozen period set out in Sections A to D, such as the encashment of Additional Teaching Posts for English and the fractional staff entitlement for claiming Fractional Post Cash Grant.",
        v11: "My school will refund to the Education Bureau any over-payment of grant.",
    },
    calculate: [
        {
            text: "paid sick/maternity/special tuberculosis leave;",
        },
        {
            text: "paid study leave;",
        },
        {
            text: "paid leave for teachers for juror or witness service;",
        },
        {
            text: "paid leave for a maximum of 14 days per school year for special events as specified in the Annex to EDB Circular No. 1/2006;",
        },
        {
            text: "other paid leave (<b>please specify the reason</b>);",
        },
        {
            text: "no-pay sick/maternity/special tuberculosis leave; and",
        },
        {
            text: "other no-pay leave.",
        },
    ],
    notes: {
        calculateLast:
            "Please note that granting of leave should follow EDB Circular No. 1/2006.",
        v9End: " at any point in time; and",
    },
    symbol: {
        1: "(i) ",
        2: "(ii) ",
        3: "(iii) ",
        4: "(iv) ",
        5: "(v) ",
        6: "(vi) ",
        7: "(vii) ",
    },
    symbolList: [
        {
            text: "(a)",
        },
        {
            text: "(b)",
        },
        {
            text: "(c)",
        },
        {
            text: "(d)",
        },
        {
            text: "(e)",
        },
        {
            text: "(x)",
        },
        {
            text: "(z)",
        },
    ],
};
export default Form030EN;
